import { gql } from '@apollo/client';
export const SEARCH_CABLE_FROM_ENDS = gql`
  query SearchCableFromEnds($searchInput: SearchInput) {
    searchCableFromEnds(searchInput: $searchInput) {
      items {
        id
        equipmentId
      }
    }
  }
`;
export const SEARCH_CABLE_TO_ENDS = gql`
  query SearchCableToEnds($searchInput: SearchInput) {
    searchCableToEnds(searchInput: $searchInput) {
      items {
        id
        equipmentId
      }
    }
  }
`;
